// Keep Frappe realtime on WebSocket and invalidate the pre-remediation print Page cache.
//
// This file is a Frappe bundle entrypoint. bench build publishes it under a
// content-hashed URL, and hooks.py registers it before every other Siach script.

frappe.provide("frappe.realtime");

(function () {
	var PRINT_PAGE_CACHE_KEY = "_page:print";
	var PRINT_PAGE_CACHE_VERSION_KEY = "_siach_print_page_dom_v2";

	try {
		if (window.localStorage.getItem(PRINT_PAGE_CACHE_VERSION_KEY) !== "2") {
			window.localStorage.removeItem(PRINT_PAGE_CACHE_KEY);
			window.localStorage.setItem(PRINT_PAGE_CACHE_VERSION_KEY, "2");
		}
	} catch (error) {
		// Storage can be disabled by browser policy. A fresh profile or normal
		// Frappe cache invalidation still receives the transformed Page response.
	}
})();

(function () {
	var TRANSPORTS = ["websocket"];
	var COMPATIBILITY_ERROR =
		"Siach realtime disabled: this Frappe client cannot guarantee WebSocket-only initialization.";

	function disable_realtime(ctx) {
		ctx.__siach_realtime_disabled = true;
		if (window.console && typeof window.console.error === "function") {
			window.console.error(COMPATIBILITY_ERROR);
		}
	}

	function pin_transport(ctx) {
		var socket = ctx && ctx.socket;
		if (socket && socket.io && socket.io.opts) {
			socket.io.opts.transports = TRANSPORTS;
			return socket;
		}
		return null;
	}

	// frappe.socketio aliases frappe.realtime on supported Frappe releases.
	var target = frappe.socketio || frappe.realtime;
	if (!target || typeof target.init !== "function" || target.__siach_ws_only) {
		return;
	}
	target.__siach_ws_only = true;

	var orig_init = target.init;
	var supports_lazy = typeof target.connect === "function";
	if (!supports_lazy) {
		target.init = function () {
			disable_realtime(this);
			return null;
		};
		return;
	}

	target.init = function (port, lazy_connect) {
		// Construct with autoConnect disabled, pin the manager options, and only
		// then permit the first connection.
		orig_init.call(this, port, true);
		if (!this.socket) {
			return null;
		}

		if (!pin_transport(this)) {
			disable_realtime(this);
			return null;
		}

		if (!lazy_connect) {
			this.connect();
		}
		return this.socket;
	};
})();
